const NumberRE = /^-?(\d{1,3}(,\d{3})*)?(\.\d+)?$/
const CommaRE = /,/g

export function normalizeNumberString(value: string) {
  // 匹配 100,000.233 这种格式
  if (NumberRE.test(value)) value = value.replaceAll(CommaRE, '')
  return value
}
